import React from "react";
// Components
import { SyestemSettings } from "view/pages";
import { SystemTheme } from "./Components";
import SystemSettings from "../SystemSettings";
import { DefaultBackGroundImage } from "./Components/DefaultBackGroundImage";

interface IProps {
  setFieldValue: any;
  values: any;
  errors: any;
  editMode?: any;
}

export const Styling: React.FC<IProps> = ({
  setFieldValue,
  values,
  errors,
  editMode,
}) => {
  return (
    <div className="w-full bg-bgWhite dark:bg-secondaryLight pt-4 pb-20 rounded-lg">
      <div className="px-12">
        {/* System themes */}
        <SystemTheme
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          editMode={editMode}
        />
        {/* Change background image of Login and forget screen */}
        <SystemSettings
          setFieldValue={setFieldValue}
          values={values}
          text={`For the best results on all devices, use an image that's at least 1024 x 706 pixels and file size less than 25MB.`}
          editMode={editMode}
        />
        {/* Default BackGround for mobile */}
        <DefaultBackGroundImage
          setFieldValue={setFieldValue}
          values={values}
          editMode={editMode}
        />
      </div>
    </div>
  );
};
